import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;

  .btn-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.25rem;
      height: 2.25rem;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 0.5rem;
      color: #9ca3af;
      cursor: pointer;
      transition: all 0.2s;
      
      svg {
        font-size: 1rem;
      }
    }
    
    button:hover {
      border-color: #111718;
      color: #111718;
    }
    
    button.active {
      background: #111718;
      border-color: #111718;
      color: #ffffff;
    }
  }

  p {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    
    span {
      font-weight: 600;
      color: #111718;
    }
  }

  .sort-container {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    white-space: nowrap;
  }

  .sort-input {
    padding: 0.5rem 0.75rem;
    padding-right: 2rem;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: #111718;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 180px;
  }

  .sort-input:focus {
    outline: none;
    border-color: #111718;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    
    .btn-container {
      order: 1;
    }
    
    p {
      order: 2;
      text-align: center;
    }
    
    .sort-container {
      order: 3;
      justify-content: center;
    }
  }
`;

export default Wrapper;
